import { Badge } from '@mantine/core';

import { SCUD_STATUS } from '@/shared/constant/scudMapping';
import { TScudMatchStatus } from '@/shared/types/scudMapping.types';

export const ScudStatusBadge = ({ status }: { status: TScudMatchStatus }) => {
	const { label, color } = SCUD_STATUS[status] ?? { label: `${status}`, color: 'gray' };

	return (
		<Badge color={color} variant="light" radius="sm" tt="none" miw="max-content">
			{label}
		</Badge>
	);
};
